/**
 * @generated SignedSource<<7d82439cbed45baddb73026929eeea95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SpecializationFieldsDialog_User$data = {
  readonly profile: {
    readonly industry: {
      readonly id: string;
    } | null | undefined;
    readonly specializations: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "SpecializationFieldsDialog_User";
};
export type SpecializationFieldsDialog_User$key = {
  readonly " $data"?: SpecializationFieldsDialog_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpecializationFieldsDialog_User">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpecializationFieldsDialog_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Industry",
          "kind": "LinkedField",
          "name": "industry",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Specialization",
          "kind": "LinkedField",
          "name": "specializations",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "6cb304221d829c0456c3c8844fda5e85";

export default node;
